module.exports = __webpack_public_path__ + "img/republik.62cbb457.png";